module.exports = __webpack_public_path__ + "img/logo2.682a3bce.svg";